import React, { PureComponent } from 'react'
import styled, { keyframes } from 'styled-components'
import LoadingWheel from '../loadingWheel/LoadingWheel'

import { connect } from 'react-redux'
import { ISize } from '../../helpers/data/size'

import { IStore } from '../../redux/reducers/index'
import assetSelector from '../../redux/selectors/app/assetSelector'
import AnimationAsset from './AnimationAsset'
import ImageAsset from './ImageAsset'
import RandomAsset from './RandomAsset'
import { IAssetData, assetTypes, IRandomAssetData, FreezePosition } from '../../helpers/data/assetData'

const defaultRandomUid = 'abcdefghijklmnopqrstuvwxyz'

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
`

const fadeInAnim = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

const LoaderWrapper = styled.div`
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.25);
	position: absolute;
	top: 0;
	left: 0;
	animation: ${fadeInAnim} 3s ease-out 1s;
	animation-fill-mode: both;
`

const LoaderElement = styled.div`
	width: 100%;
	height: 100%;
	max-width: 40px;
	max-height: 40px;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	margin: auto;
`

interface IAssetProps {
	asset: IAssetData | IRandomAssetData
	onLoad?: () => void
	onComplete?: () => void
	path: string
	uid: string
	size: ISize
	renderer?: string
	alt?: string
	ariaHidden?: boolean
	areAnimationsEnabled?: boolean
	freezePosition?: FreezePosition
}

interface IAssetState {
	isLoaded: boolean
}

class Asset extends PureComponent<IAssetProps, IAssetState> {
	static defaultProps = {
		uid: defaultRandomUid,
	}

	state = {
		isLoaded: false,
	}

	onAssetLoaded = () => {
		this.setState({
			isLoaded: true,
		})
		if (this.props.onLoad) {
			this.props.onLoad()
		}
	}

	buildAsset(assetData: IAssetData | IRandomAssetData) {
		if (assetData.type === assetTypes.ANIMATION) {
			return (
				<AnimationAsset
					assetData={assetData as IAssetData}
					onAssetLoaded={this.onAssetLoaded}
					onComplete={this.props.onComplete}
					path={this.props.path}
					size={this.props.size}
					renderer={this.props.renderer}
					areAnimationsEnabled={this.props.areAnimationsEnabled}
					freezePosition={this.props.freezePosition}
				/>
			)
		} else if (assetData.type === assetTypes.RANDOM) {
			return (
				<RandomAsset
					assetData={assetData as IRandomAssetData}
					uid={this.props.uid}
					onAssetLoaded={this.onAssetLoaded}
					onComplete={this.props.onComplete}
					areAnimationsEnabled={this.props.areAnimationsEnabled}
					freezePosition={this.props.freezePosition}
				/>
			)
		} else {
			return (
				<ImageAsset assetData={assetData as IAssetData} onAssetLoaded={this.onAssetLoaded} path={this.props.path} alt={this.props.alt} ariaHidden={this.props.ariaHidden} />
			)
		}
	}

	render() {
		return (
			<Wrapper>
				{this.buildAsset(this.props.asset)}
				{!this.state.isLoaded && (
					<LoaderWrapper>
						<LoaderElement>
							<LoadingWheel />
						</LoaderElement>
					</LoaderWrapper>
				)}
			</Wrapper>
		)
	}
}

const mapStateToProps = (state: IStore) => {
	return assetSelector(state)
}

const defaultAsset: IAssetData = {
	type: 'static',
	path: '',
}
export { defaultAsset }

export default connect(mapStateToProps)(Asset)
